module.exports = __webpack_public_path__ + "img/1111.1df1438f.png";